import React from "react";
import { useTranslation } from "react-i18next";
import { formatMinutes } from "./scheduleUtils";
import "./ScheduleTable.css";

const ScheduleTable = ({ schedule, onRideClick }) => {
  const { t } = useTranslation();
  return (
    <div className="table-responsive">
      <table className="table dispatch-overview-table">
        <thead>
          <tr>
            <th>{t("HOUR")}</th>
            <th>{t("AVAILABLE_SLOTS")}</th>
            <th>{t("ORDER_NUMBER")}</th>
          </tr>
        </thead>
        <tbody>
          {schedule.map((slot, index) => {
            const hasCapacity = Number.isFinite(slot.capacity) && slot.capacity > 0;
            let className = "";
            if (hasCapacity && slot.count > slot.capacity) className = "over-capacity";
            else if (slot.count > 0) className = "has-orders";
            return (
              <tr key={`${slot.startMinutes}-${index}`} className={className}>
                <td>{formatMinutes(slot.startMinutes)} – {formatMinutes(slot.endMinutes)}</td>
                <td>{slot.count} / {slot.capacity != null ? slot.capacity : "—"}</td>
                <td className="dispatch-overview-order-numbers">
                  {slot.orderNumbers.length
                    ? slot.orderNumbers.map(({ orderNumber, ride }, i) => (
                        <span key={orderNumber}>
                          {i > 0 && ", "}
                          <span className="dispatch-overview-order-link" onClick={() => onRideClick(ride)}>
                            {orderNumber}
                          </span>
                        </span>
                      ))
                    : <span className="dispatch-overview-order-numbers-empty">-</span>}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default ScheduleTable;
